<template>
	<!-- CHECK COMPONENT IF IN USE -->
	<v-card class="elevation-1" color="white">
		<v-card-title class="blue--text lighten-1">
			<v-btn class="blue--text lighten-1" text @click="cancelViewBooking"
				><v-icon large color="blue lighten-1" @click="cancelViewBooking">mdi-chevron-left</v-icon>Back</v-btn
			>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-divider />
		<!-- begin the card import -->

		<!--the card -->
		<v-card-text>
			<v-row justify="center" align="center" class="pb-0 mb-0">
				<v-col justify="center" align="center">
					<v-tooltip v-if="booking.status == 'cancelled'" bottom justify="center" align="center">
						<template #activator="{ on, attrs }">
							<v-list-item-title :class="['red--text', 'lighten-1', 'font-weight-bold']" justify="center" align="center">
								<p v-bind="attrs" v-on="on">{{ booking.status }} <v-icon color="primary" dark v-bind="attrs" small v-on="on"> help </v-icon></p>
							</v-list-item-title>
						</template>
						<span
							><v-row
								><v-col
									>This booking was cancelled by {{ booking.cancelledBy == 'professional' ? 'the locum' : 'you' }} on
									{{ dateFormattedMomentjs(booking.updatedAt) }}</v-col
								></v-row
							></span
						>
					</v-tooltip>
					<v-list-item-title v-else justify="center" align="center" :class="['blue--text', 'lighten-1', 'font-weight-bold']">{{ booking.status }}</v-list-item-title>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-list-item justify="space-around">
						<v-spacer />

						<v-skeleton-loader v-if="!avatar" type="avatar" :loading="true"> </v-skeleton-loader>

						<v-list-item-avatar v-else-if="avatar && avatar != 'no-avatar'" size="90" color="grey lighten-2" class="outlined">
							<v-img :src="avatar"></v-img>
						</v-list-item-avatar>

						<v-list-item-avatar v-else size="90" color="grey lighten-2" class="outlined">
							<v-img :src="no_avatar"></v-img>
						</v-list-item-avatar>

						<v-spacer />
					</v-list-item>

					<v-list-item>
						<v-list-item-content align="center" justify="center">
							<v-list-item-title class="title" v-text="booking.company.name"></v-list-item-title>
							<v-list-item-subtitle class="title blue--text lighten-1" color="orange" v-text="booking.professional.profession"></v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="booking && 'booking_dates' in booking">
						<v-list-item-content align="center" justify="center">
							<v-row v-if="booking.booking_dates.length <= 9" class="pt-2" no-gutters align="center" justify="center">
								<calendar-date-icon
									v-for="date in booking.booking_dates"
									:key="date"
									color="green"
									:card_color="''"
									:card_text_color="''"
									:date="date"
									small
									class="ml-1 mr-1 mt-2 mb-0 justify-center text-center"
								>
								</calendar-date-icon>
							</v-row>
							<!-- special compact view below -->
							<v-row v-else no-gutters align="center" justify="center">
								<calendar-date-strip-smart-group :dates="booking.booking_dates"></calendar-date-strip-smart-group>
							</v-row>
						</v-list-item-content>
					</v-list-item>
				</v-col>
			</v-row>

			<!--START -->
			<v-row>
				<v-col>
					<p class="font-weight-bold">Start Time</p>
					<v-text-field v-model="bookingTimes[0]" placeholder="Start Time:" readonly filled dense></v-text-field>
				</v-col>

				<!--END -->
				<v-col>
					<p class="font-weight-bold">End Time</p>
					<v-text-field v-model="bookingTimes[1]" placeholder="Start Time:" readonly filled dense></v-text-field>
				</v-col>
			</v-row>

			<!-- end timepickers -->

			<v-row>
				<v-col>
					<v-list-item>
						<v-list-item-content class="pt-0 pb-0">
							<p>
								<b>Lunch Details</b>
							</p>
							<span v-if="bookingLunch && bookingLunch.allowed">Lunch Break</span>
							<span v-if="bookingLunch && !bookingLunch.allowed">No Lunch Break</span>
							<span v-if="bookingLunch && bookingLunch.paid">Paid Lunch Break</span>
							<span v-if="bookingLunch && bookingLunch.period == 1">1 hour Lunch Break</span>
							<span v-if="bookingLunch && bookingLunch.period == 0.5">30 minutes Lunch</span>
							<span v-if="!bookingLunch">Lunch details not in payload</span>
						</v-list-item-content>
					</v-list-item>
				</v-col>
			</v-row>

			<v-row>
				<v-col>
					<v-list-item>
						<v-list-item-content class="pt-0 pb-0">
							<p class>
								<b>Notes</b>
							</p>

							<v-textarea v-model="bookingNotes" auto-grow filled color="primary" rows="1" :readonly="true"></v-textarea>
						</v-list-item-content>
					</v-list-item>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import moment from 'moment';
import { bus } from '@/main';
import store from '@/store';
import axios from 'axios';

import CalendarDateIcon from '@/components/custom/CalendarDateIcon.vue';
import CalendarDateStripSmartGroup from '@/components/custom/CalendarDateStripSmartGroup.vue';

export default {
	name: 'LocumViewHistoricalBooking',
	components: { CalendarDateIcon, CalendarDateStripSmartGroup },
	data: () => ({
		no_avatar: store.getters.noAvatar,
		avatar: false,
		desiresCancell: false,
		cancellationReason: '',
		cancellErrMessage: [],
	}),
	computed: {
		booking() {
			return store.getters.getSelectedBooking;
		},

		bookingLunch() {
			return false;
		},

		bookingNotes() {
			return this.booking.notes;
		},

		bookingTimes() {
			return [this.booking.start_time, this.booking.end_time];
		},

		computedstartDateFormattedMomentjs() {
			return this.startdate ? moment(this.startdate).format('dddd, MMMM Do YYYY') : '';
		},
		computedendDateFormattedMomentjs() {
			return this.enddate ? moment(this.enddate).format('dddd, MMMM Do YYYY') : '';
		},
	},
	mounted() {
		const token = store.getters.jwtToken; //get the token from store

		axios
			.get(store.getters.getDOCUMENTS + '/images/logo/' + this.booking.company.id, { headers: { Authorization: token } })
			.then(response => {
				this.avatar = 'data:image/png;base64,' + response.data.data;
				this.$emit('update-render');
				// eslint-disable-next-line
			})
			.catch(() => {
				this.avatar = 'no-avatar';
			});
	},
	beforeDestroy() {
		// bus.$off('intent:submit-forms');
	},
	methods: {
		dateFormattedMomentjs(date) {
			return date ? moment(date).format('Do MMMM YYYY') : '';
		},
		//events
		functionEvents(date) {
			const [, , day] = date.split('-');
			if ([12, 17, 28].includes(parseInt(day, 10))) return true;
			if ([1, 19, 22].includes(parseInt(day, 10))) return ['primary', 'accent'];
			return false;
		},
		cancelViewBooking() {
			bus.$emit('refreshRequestsReceived');
			bus.$emit('UpdateCalendar');
			bus.$emit('change-context', 'practice-dashboard-landing-zone');
		},
	},
};
</script>
